import React from "react";
import { ShieldCheck, EyeOff, Lock, CheckCircle2 } from "lucide-react";

/**
 * Anonymity Guarantee — Track 1 priority #1.
 * Single dedicated section selling the platform's biggest differentiator.
 */
export default function AnonymityGuarantee() {
  return (
    <section className="lp-section" data-testid="landing-anonymity-section">
      <div className="lp-container">
        <div className="lp-section-head">
          <div className="font-mono lp-section-tag">/ ANONYMITY GUARANTEE</div>
          <h2 className="font-serif-display lp-h2">
            No identity reaches the other side<br/>until you decide.
          </h2>
        </div>

        <div className="anon-shield-card" style={{ padding: "32px 28px", marginTop: 28, position: "relative", zIndex: 1 }}>
          <div style={{ display: "grid", gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)", gap: 36 }} className="anon-grid">
            <div>
              <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 14 }}>
                <ShieldCheck size={20} color="var(--amber-400)" />
                <span className="font-mono" style={{ fontSize: 11, letterSpacing: ".15em", color: "var(--amber-400)" }}>
                  PRE-AWARD STATE
                </span>
              </div>
              <p style={{ fontSize: 16, lineHeight: 1.7, color: "var(--ink-dim)", marginBottom: 18 }}>
                Suppliers see <b style={{ color: "var(--ink)" }}>only the structured RFQ</b> — category, quantity, region, urgency, spec.
                Buyers see <b style={{ color: "var(--ink)" }}>only ranked anonymous quotes</b> — price, lead time, validity, score.
              </p>
              <div style={{ display: "grid", gap: 10 }}>
                <Row icon={EyeOff} text="No company name, logo, or contact info exposed" />
                <Row icon={EyeOff} text="No buyer identity shown to suppliers, no supplier identity shown to buyers" />
                <Row icon={Lock} text="Spec and document attachments scrubbed of identifiers" />
              </div>
            </div>

            <div>
              <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 14 }}>
                <CheckCircle2 size={20} color="var(--emerald, #10b981)" />
                <span className="font-mono" style={{ fontSize: 11, letterSpacing: ".15em", color: "var(--emerald, #10b981)" }}>
                  POST-AWARD STATE
                </span>
              </div>
              <p style={{ fontSize: 16, lineHeight: 1.7, color: "var(--ink-dim)", marginBottom: 18 }}>
                The moment you award a quote, the <b style={{ color: "var(--ink)" }}>winning supplier's identity is revealed to you only</b>,
                and your identity to them. Other suppliers never learn who awarded the deal — or that an award happened.
              </p>
              <div style={{ display: "grid", gap: 10 }}>
                <Row icon={CheckCircle2} text="Counterparty contact card revealed only post-award" />
                <Row icon={CheckCircle2} text="Trade settlement happens directly, off-platform" />
                <Row icon={CheckCircle2} text="Losing suppliers never learn the awarded price or buyer identity" />
              </div>
            </div>
          </div>
        </div>

        <p style={{ marginTop: 18, fontSize: 12, color: "var(--ink-mute)", textAlign: "center" }}>
          Read the full <a href="/privacy" style={{ color: "var(--amber-400)" }}>privacy policy</a>.
        </p>
      </div>
    </section>
  );
}

function Row({ icon: Icon, text }) {
  return (
    <div style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
      <Icon size={14} color="var(--ink-mute)" style={{ marginTop: 4, flexShrink: 0 }} />
      <span style={{ fontSize: 14, color: "var(--ink-dim)" }}>{text}</span>
    </div>
  );
}
